module.exports = __webpack_public_path__ + "img/beijing1.b04136fd.png";